import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './MyPage.css';

const MyPage = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const menuItems = [
    {
      title: '쇼핑 정보',
      items: [
        { icon: '📦', label: '주문내역', path: '/orders' },
        { icon: '❤️', label: '찜한 상품', path: '/wishlist' },
        { icon: '🛒', label: '장바구니', path: '/cart' },
        { icon: '🎁', label: '포인트', path: '/mypage/points' },
        { icon: '🎟️', label: '쿠폰', path: '/mypage/coupons' },
      ]
    },
    {
      title: '회원 정보',
      items: [
        { icon: '👤', label: '회원정보 수정', path: '/profile' },
        { icon: '🔒', label: '비밀번호 변경', path: '/mypage/change-password' },
      ]
    },
    {
      title: '고객센터',
      items: [
        { icon: '💬', label: '1:1 문의', path: '/inquiry' },
        { icon: '📢', label: '공지사항', path: '/notice' },
        { icon: '❓', label: 'FAQ', path: '/faq' },
      ]
    }
  ];

  return (
    <div className="mypage-container">
      <div className="mypage-header">
        <div className="mypage-header-content">
          <div className="mypage-header-top">
            <h1>My Page</h1>
          </div>
          
          <div className="user-profile">
            <div className="user-avatar">👤</div>
            <div className="user-info">
              <p className="user-name">{user.name || user.username || '사용자'}</p>
              <p className="user-email">{user.email || 'email@example.com'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mypage-content">
        {menuItems.map((section, idx) => (
          <div key={idx} className="menu-section">
            <div className="section-header">
              <h2>{section.title}</h2>
            </div>
            <div className="menu-items">
              {section.items.map((item, itemIdx) => (
                <Link key={itemIdx} to={item.path} className="menu-item">
                  <div className="menu-item-left">
                    <span className="menu-icon">{item.icon}</span>
                    <span className="menu-label">{item.label}</span>
                  </div>
                  <div className="menu-item-right">
                    {item.badge && <span className="menu-badge">{item.badge}</span>}
                    <span className="menu-arrow">›</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyPage;